import Ajv from 'ajv';
import * as GarageSheme from './scheme.json';

const ajv = new Ajv();
export const GarageValidator = ajv.compile(GarageSheme);
